import React from "react";
import { Helmet } from "react-helmet";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { IconButton, Typography, CircularProgress } from "@mui/material";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Copyright from "../components/Copyright";
import { useTranslation } from "react-i18next";
import FarmAppLogo from "../assets/logo/FarmAppLogo.png";
import BackButtonIcon from "../assets/Icon/BackButtonIcon.png";
import PasswordVisibility from "../components/PasswordVisibility";
import api from "../globals/axios";
import { saveAuth } from "../globals/authentication";
import { SERVER_BASE_ADDRESS } from "../globals/const";
import { useAlert } from "../components/Alert";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmpassword] = useState("");
  const [error, setError] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();
  function handleSubmit(e) {
    setLoading(true);
    e.preventDefault();
    if (password !== confirmpassword) {
      setLoading(false);
      setError("Passwords do not match!");
      return;
    }

    api
      .post(`${SERVER_BASE_ADDRESS}/auth/reset-password`, {
        password: password,
      })
      .then((result) => {
        if (result && result.data && result.data.auth) {
          saveAuth(result.data.auth);
          showAlert("success", result.data.message);
          setTimeout(() => {
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: "REGISTER_TOKEN",
                  token: result.data.token,
                })
              );
            }
            window.open("/", "_self");
            setLoading(false);
          }, 1000);
        }
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.non_field_errors
        ) {
          let message = `Error - ${err.response.data.non_field_errors[0]}`;
          showAlert(message);
          setLoading(false);
        }
      });
  }

  return (
    <Container component="main" maxWidth="xs">
      <Helmet>
        <title>Reset Password - Farmapp</title>
      </Helmet>
      <IconButton
        edge="start"
        sx={{ mx: "0.1rem", marginTop: "10px" }}
        aria-label="back"
        onClick={() => navigate(-1)}
      >
        <img src={BackButtonIcon} />
      </IconButton>
      <CssBaseline />
      <div
        style={{
          display: "flex",
          padding: "20px",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          alt="farmapp"
          src={FarmAppLogo}
          style={{ width: "206", height: "188px" }}
        />
        <form
          style={{
            width: "100%",
            marginTop: 50,
          }}
          noValidate
          onSubmit={handleSubmit}
        >
          <Typography variant="h6" align="center" mb={2}>
            {t("Reset Your Password ")}
          </Typography>

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label={t("Password")}
            type={showPassword ? "text" : "password"}
            id="Password"
            autoComplete="current-password"
            value={password}
            InputProps={{
              endAdornment: (
                <PasswordVisibility
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                />
              ),
            }}
            onChange={(event) => setPassword(event.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="confirmpassword"
            label={t("Confirm Password")}
            type={showPassword ? "text" : "password"}
            id="confirmpassword"
            autoComplete="current-password"
            value={confirmpassword}
            InputProps={{
              endAdornment: (
                <PasswordVisibility
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                />
              ),
            }}
            onChange={(event) => setConfirmpassword(event.target.value)}
            error={!!error}
            helperText={error}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2, color: "white" }}
          >
            {loading && !error && password ? (
              <CircularProgress size={28} style={{ color: "white" }} />
            ) : (
              t("Submit")
            )}{" "}
          </Button>
        </form>
      </div>

      <Box mt={4}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default ResetPassword;
